import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/meucorreios/dialog.css';
import '../../../assets/css/meucorreios/icones-correios.css';
import InputSenha from '../../../components/form/InputSenha';
import Input from '../../../components/form/Input';
import { useForm } from 'react-hook-form';
import {
  ENVIAR_TOKEN,
  ALTERAR_SENHA,
  ALTERAR_SENHA_DEPENDENTE,
} from '../../../services/meuCorreios';
import { yupResolver } from '@hookform/resolvers/yup';
import { createFormSchemas } from './FormSchema';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import InputToken from '../../../components/form/InputToken';
import { getIPAddress } from '../../../components/utils/GetIPAddress';

function FormAlterarSenha({ acaoCancelar, dados, dadosDependente }) {
  const { t } = useTranslation();
  const { formSchemaSenha } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaSenha) });
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const [modalAbertoSenha, setModalAbertoSenha] = React.useState(true);
  const [modalAbertoToken, setModalAbertoToken] = React.useState(false);

  const openModalToken = () => {
    setModalAbertoSenha(false);
    setModalAbertoToken(true);
  };
  const { request } = useFetch();
  const [senha, setSenha] = React.useState();

  const handleSubmit = async (data) => {
    setSenha(data.novaSenha);
    var usuario;
    usuario = dados.idCorreios;

    const token = {
      meioEnvio: meioEnvio,
      funcionalidade: 'ALTERAR_SENHA',
    };
    const { response } = await request(ENVIAR_TOKEN(usuario, token, ipAddress));
    if (response.ok) {
      if (meioEnvio == 'E') {
        abreAlertaDialog(t('principal.messages.success.token_sent_email'));
      } else {
        abreAlertaDialog(t('principal.messages.success.token_sent_phone'));
      }
      openModalToken();
    }
  };
  const [meioEnvio, setMeioEnvio] = React.useState('E');
  const handleMeioEnvio = (event) => {
    setMeioEnvio(event.target.value);
  };
  const reenviaToken = async () => {
    var usuario;
    usuario = dados.idCorreios;

    const token = {
      meioEnvio: meioEnvio,
      funcionalidade: 'ALTERAR_SENHA',
    };
    const { response } = await request(ENVIAR_TOKEN(usuario, token, ipAddress));
    if (response.ok) {
      if (meioEnvio == 'E') {
        abreAlertaDialog(t('principal.messages.success.token_sent_email'));
      } else {
        abreAlertaDialog(t('principal.messages.success.token_sent_phone'));
      }
      openModalToken();
    }
  };
  const alterar = async () => {
    const token =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token.length < 6) {
      abreAlertaDialog(t('principal.messages.validation.token_digits_required'));
    } else {
      const senhaEnviar = {
        senha: senha,
        token: token,
      };

      if (dadosDependente) {
        const { response } = await request(
          ALTERAR_SENHA_DEPENDENTE(
            dados.idCorreios,
            dadosDependente.idCorreios,
            senhaEnviar,
            ipAddress,
          ),
        );
        if (response.ok) {
          abreAlertaDialog(t('principal.messages.success.password_changed'));
          acaoCancelar();
        }
      } else {
        const { response } = await request(
          ALTERAR_SENHA(dados.idCorreios, senhaEnviar, ipAddress),
        );
        if (response.ok) {
          abreAlertaDialog(t('principal.messages.success.password_changed'));
          acaoCancelar();
        }
      }
    }
  };
  const fechar = (ev) => {
    ev.preventDefault();
    setModalAbertoSenha(true);
    setModalAbertoToken(false);
    handleReset();
    acaoCancelar();
  };
  const fecharToken = (ev) => {
    ev.preventDefault();
    setModalAbertoSenha(true);
    setModalAbertoToken(false);
    acaoCancelar();
  };
  const handleReset = () => {
    const form = document.getElementById('formSenha');
    const campos = form.querySelectorAll('input');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };
  return (
    <>
      {modalAbertoSenha && (
        <form id="formSenha" onSubmit={methods.handleSubmit(handleSubmit)}>
          <InputSenha
            type="password"
            id="novaSenha"
            name="novaSenha"
            placeholder=""
            maxLength="15"
            label={t('principal.forms.labels.new_password')}
            {...formMethods}
          />
          <InputSenha
            type="password"
            id="confirmaSenha"
            name="confirmaSenha"
            placeholder=""
            maxLength="15"
            label={t('principal.forms.labels.confirm_new_password')}
            {...formMethods}
          />
          {dados?.ddiMovel === '55' || !dados?.ddiMovel ? (
            <div className="receber-token radio-container">
              <p className="">
                {t('principal.forms.messages.token_delivery_method')}
              </p>

              <label className="radio">
                <Input
                  type="radio"
                  id="E"
                  name="meioEnvio"
                  value="E"
                  checked={meioEnvio === 'E'}
                  onChange={handleMeioEnvio}
                  {...formMethods}
                />
                <div className="subtitulo-p">{t('principal.forms.labels.email_option')}</div>
              </label>

              <label className="radio">
                <Input
                  type="radio"
                  id="C"
                  name="meioEnvio"
                  value="C"
                  //disabled="true"
                  checked={meioEnvio === 'C'}
                  onChange={handleMeioEnvio}
                  {...formMethods}
                />
                <div className="subtitulo-p">{t('principal.forms.labels.phone_option')}</div>
              </label>
            </div>
          ) : (
            <label>
              {t('principal.forms.messages.token_email_only')}
            </label>
          )}
          <br />
          <div className="dialog-footer">
            <button className="btn-txt btn-fecha-dialog" onClick={fechar}>
              {t('principal.forms.buttons.cancel')}
            </button>
            <button className="btn-pre" id="btn-senha" type="submit">
              {t('principal.forms.buttons.change')}
            </button>
          </div>
        </form>
      )}
      {modalAbertoToken && (
        <form id="formToken">
          <div id="finaliza-cadastro" className="conteudo">
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt="Imagem de perfil da Carol"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t('principal.forms.titles.finalize_change')}</h2>
              {meioEnvio === 'E' && (
                <p className="txt-finalizacao">
                  {t('principal.forms.messages.finalize_password_change_email')}
                </p>
              )}
              {meioEnvio === 'C' && (
                <p className="txt-finalizacao">
                  {t('principal.forms.messages.finalize_password_change_phone')}
                </p>
              )}
              <div className="campo-txt">
                <InputToken />
              </div>
              <div className="btns-row">
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  {t('principal.forms.buttons.resend_code')}
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t('principal.forms.buttons.finalize')}
                </button>
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={fecharToken}
                >
                  {t('principal.forms.buttons.cancel')}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}
export default FormAlterarSenha;
